document.addEventListener("DOMContentLoaded", () => {
  function addHandleForRecentProductsFetch() {
    const handles = localStorage.getItem("recently-viewed");
    const productHandle =
      document.querySelector(".js-product").dataset.productHandle;

    if (handles) {
      if (handles.includes(productHandle)) return;

      const handlesToAdd = [productHandle, ...handles.split(",")];

      if (handlesToAdd.length > 10) {
        handlesToAdd.pop();
      }

      localStorage.setItem("recently-viewed", handlesToAdd.join(","));

      return;
    }

    localStorage.setItem("recently-viewed", productHandle);
  }
  addHandleForRecentProductsFetch();
});
document.addEventListener('DOMContentLoaded', function() {
  const slides = document.querySelectorAll('.product__media-item');
  if (!slides || slides.length < 2) return;

  let current = 0;
  const interval = 4000;

  setInterval(function() {
    current = (current + 1) % slides.length;
    slides[current].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
  }, interval);
});
document.addEventListener('DOMContentLoaded', function() {
  const interval = 4000;

  function initAutoplay() {
    const galleryEl = document.querySelector('.product-grid__item--media .swiper');
    if (!galleryEl || !galleryEl.swiper) return;

    const swiper = galleryEl.swiper;
    if (swiper.slides.length < 2) return;

    setInterval(function() {
      swiper.slideNext();
    }, interval);
  }

  // Swiper may initialize after DOMContentLoaded
  setTimeout(initAutoplay, 1000);
});